import * as React from 'react';

const AddButtonSuccessMessage = ({ caption  })=>/*#__PURE__*/ React.createElement("div", {
        className: "add-button-success-message"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "add-button-success-message__text"
    }, caption))
;

export { AddButtonSuccessMessage };
//# sourceMappingURL=AddButtonSuccessMessage.js.map
